export default __webpack_public_path__ + "static/sirio-3-d099c8722bb74f98e9479dc4137dc685.jpg";